var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c(_vm.layout,{tag:"component"}),(!_vm.$store.state.layoutSelected)?_c('div',{staticClass:"app__loader"},[_c('Loader',{staticClass:"app__loader-block"})],1):_vm._e(),_c('Sprite')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }